import React from 'react';
import './NavbarDetail.css';
// import { SmoothScrollLink } from "organism-react-scroll-nav";
import { useHistory } from 'react-router-dom';

class NavbarDetail extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);

    this.state = {
      isTop: true,
    };
    this.onScroll = this.onScroll.bind(this);
  }

  componentDidMount() {
    this._isMounted = true;
    document.addEventListener('scroll', () => {
      const isTop = window.scrollY < 100;
      if (isTop !== this.state.isTop && this._isMounted) {
        this.onScroll(isTop);
        document.getElementById('navbar').classList.toggle('navbarScrooled');
      }
    });
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  onScroll(isTop) {
    this.setState({ isTop });
  }

  render() {
    return (
      <nav className="navbar navbar-expand-lg navbar-light bg-transparant fixed-top navbarDetail" id="navbar">
        <a className="navbar-brand" href="./">
          GarutMenawan
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-toggle="collapse"
          data-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div className="collapse navbar-collapse" id="navbarSupportedContent">
          <ul className="navbar-nav ml-auto text-center">
            <li>
              <a
                href="/"
                onClick={() => {
                  useHistory().goBack();
                }}
                className="nav-link rounded rounded-pill"
              >
                KEMBALI
              </a>
            </li>
          </ul>
        </div>
      </nav>
    );
  }
}

export default NavbarDetail;
